import {FC} from 'react'
import { getStyledAboutCard } from '../../styled-components/AboutSection.styled'

export interface AboutCardProps {
    num: number
    title: string
    description: string
}

export const AboutCard: FC<AboutCardProps> = ({num, title, description}) => {

    const StyledCard = getStyledAboutCard()

    return(
        <StyledCard>
            <div className='num'>{num}.</div>
            <div className='card-title'>{title}</div>
            <div className='card-description'>{description}</div>
        </StyledCard>
    )
}